import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "@emotion/styled";
import { DownOutlined, UserOutlined, LockOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import { context } from "components/context/Context";
import logo from "../images/lingdon-LOGO.svg";
import { color } from "styles/color";
import useAPI from "components/customHook/useApi";
import useEffectOnce from "components/customHook/useEffectOnce";
import { MenuProps, Dropdown } from "antdv5";
import { Obj } from "../client_types";
import { notification } from "antdv5";
import { GETJsonTbgroup, POSTJsonLoginGetToken } from "../api";

const Wrapper = styled.div`
  position: relative;
  .photoMask {
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: ${color.primaryBlue};
    @media (min-width: 768px) {
      height: 40vh;
      min-height: 200px;
    }
  }
  .box {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    @media (min-width: 768px) {
      top: 25%;
    }
    @media (max-height: 700px) {
      top: 0%;
    }
  }
  .logoContainer {
    display: flex;
    align-items: center;
    margin-bottom: 2.5vh;
    flex-flow: column nowrap;
    img {
      filter: drop-shadow(2px 4px 16px rgba(0, 41, 88, 0.192));
      width: 6rem;
      margin-bottom: 0.5rem;
    }
    @media (min-width: 768px) {
      &:after {
        content: "岭东资讯";
        width: 100%;
        color: white;
        font-weight: 600;
        letter-spacing: 0.125rem;
        font-size: 1.5rem;
      }
    }
    @media (max-height: 700px) {
      display: none;
    }
  }
  .card {
    width: 100%;
    padding: 3rem 2rem;
    display: flex;
    flex-flow: column nowrap;
    background-color: white;
    @media (min-width: 768px) {
      width: 20vw;
      min-width: 375px;
      max-width: 450px;
      padding: 2.5rem;
      border-radius: 0.5rem;
      box-shadow: 0px 0px 32px rgba(255, 255, 255, 0.5),
        5px 10px 32px hsla(223, 43%, 22%, 0.2);
    }
    .title {
      color: ${color.primaryBlue};
      font-size: 1.8rem;
      font-weight: 700;
      margin-bottom: 2rem;
      text-align: center;
      @media (min-width: 768px) {
        font-size: 1.5rem;
      }
    }
    .ant-dropdown-link {
      background-color: white;
      text-align: left;
    }
    .label,
    .ant-dropdown-trigger {
      color: ${color.primaryBlue};
      border: none;
      outline: none;
      border-radius: 0.5rem;
      box-shadow: 2px 6px 16px hsla(223, 43%, 22%, 0.1);
      margin-bottom: 2rem;
      padding: 0.8rem;
      font-size: 0.8rem;
      font-weight: 600;
    }
    input {
      margin-left: 1rem;
      color: ${color.default};
      border: none;
      font-size: 16px;
      &:focus-within {
        outline: none;
      }
      @media (min-width: 768px) {
        font-size: 1.125rem;
      }
    }
    @media (max-height: 700px) {
      height: 100vh;
    }
  }
  .btnGroup {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-flow: column wrap;

    @media (max-height: 700px) {
      height: 50vh;
      justify-content: flex-end;
    }
  }
  .btn {
    width: 100%;
    padding: 0.8rem;
    border: none;
    outline: none;
    border-radius: 0.5rem;
    cursor: pointer;
  }
  .submitBtn {
    box-shadow: 2px 6px 16px hsla(223, 43%, 22%, 0.15);
    background-color: ${color.primaryBlue};
    color: white;
    margin: 3rem 0 1rem 0;
  }
  .backBtn {
    background-color: white;
    color: ${color.markedSecondary};
  }
`;
const StyledDrop = styled(Dropdown)`
  border-radius: 0.2rem;
  padding: 0.5rem 0.5rem;
  margin-bottom: 1rem;
  transition: all 0.3s;
`;

const Login = () => {
  const { state, dispatch } = useContext(context);
  const { handleEnter } = useAPI();
  const [api, ctx] = notification.useNotification();
  let history = useHistory();
  const [location, setLocation] = useState<Obj | null>(null);
  const [result, setResult] = useState({
    Account: "",
    Password: "",
    Id: "",
  });
  const [club, setClub] = useState("");
  const items: MenuProps["items"] =
    location?.map((data: Obj) => ({
      key: uuidv4(),
      label: `${data.Name} - ${data.Nickname}`,
      onClick: () => {
        dispatch({
          gid: data.Gid,
          clubName: data.Nickname,
          clubID: data.Name,
        });
        setClub(data.Name);
        setResult({ ...result, Id: data.Gid });
      },
    })) || [];
  const handleLogin = () => {
    POSTJsonLoginGetToken(result).then((res) => {
      if (res.Data.Token !== "") {
        dispatch({
          token: res.Data.Token,
          user: result.Account,
          character: res.Data.Role,
          onAuth: true,
          loginClubID: club,
          clubID: club,
        });
        history.push("/");
      } else if (club === "") {
        api.error({
          message: "注意！",
          description: "请选择鸽会",
          placement: "top",
        });
      } else if (res.InfoGet[0].Status === "Fail") {
        api.error({
          message: "注意！",
          description: "输入的账号密码错误",
          placement: "top",
        });
      } else if (res.InfoGet[0].Status === "Error") {
        api.error({
          message: "注意！",
          description: "系统错误，请稍后再试",
          placement: "top",
        });
      }
    });
  };
  const fetchLocation = async () => {
    setLocation(await GETJsonTbgroup(0));
  };
  const back = () => {
    history.push("/");
  };

  useEffectOnce(() => {
    fetchLocation();
  }, []);

  return (
    <>
      {ctx}
      <Wrapper>
        <div className="photoMask" />
        <div className="box">
          <div className="logoContainer">
            <img src={logo} alt="logo" />
          </div>
          <div className="card">
            <div className="title">登入</div>
            <StyledDrop menu={{ items }} trigger={["click"]}>
              <button
                className="ant-dropdown-link"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {club === "" ? "选择鸽会" : `${club} - ${state.clubName}`}{" "}
                <DownOutlined />
              </button>
            </StyledDrop>
            <div className="label">
              <UserOutlined style={{ color: `${color.primaryBlue}` }} /> 账号
              <input
                type="text"
                id="account"
                name="account"
                onChange={(e) =>
                  setResult({ ...result, Account: e.target.value })
                }
                onKeyPress={(e) => handleEnter(e, handleLogin)}
              />
            </div>
            <div className="label">
              <LockOutlined style={{ color: `${color.primaryBlue}` }} /> 密码
              <input
                type="password"
                id="password"
                name="password"
                onChange={(e) =>
                  setResult({ ...result, Password: e.target.value })
                }
                onKeyPress={(e) => handleEnter(e, handleLogin)}
              />
            </div>
            <div className="btnGroup">
              <button className="btn submitBtn" onClick={handleLogin}>
                登入
              </button>
              <button className="btn backBtn" onClick={back}>
                返回
              </button>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Login;
